export const orderCancel = {
  cancelReason: '147.', // 取消原因
  btnSubmit: '150.0' // 提交按钮
}
